import _pick from 'lodash/pick';
import { getGlobalProps } from '../utils/queryHelpers';
import { MINUTES_IN_A_HOUR, DEFAULT_NETTERMS } from '../constants/constants';

const FIELDS = [
  'id',
  'name',
  'externalId',
  'scac',
  'leadTimeWindow',
  'ratingUrl',
  'ratingPhoneNumber',
  'dispatchUrl',
  'dispatchPhoneNumber',
  'customerServicePhoneNumber',
  'mcNumber',
  'dunsNumber',
  'usDotNumber',
  'federalEinNumber',
  'netTermsId',
  'p44AccountCode',
  'insuranceProvider',
  'insurancePolicyNumber',
  'insuranceEffectiveDate',
  'insuranceExpirationDate',
  'orgId',
  'rowVersion',
  'carrierStatusId'
];

const CarrierRelationship = () => {
  const {
    orgInfo: { orgId }
  } = getGlobalProps();

  return {
    id: null,
    name: '',
    externalId: '',
    scac: '',
    leadTimeWindow: '',
    ratingUrl: '',
    ratingPhoneNumber: '',
    dispatchUrl: '',
    dispatchPhoneNumber: '',
    customerServicePhoneNumber: '',
    mcNumber: '',
    dunsNumber: '',
    usDotNumber: '',
    federalEinNumber: '',
    netTermsId: DEFAULT_NETTERMS,
    p44AccountCode: '',
    insuranceProvider: '',
    insurancePolicyNumber: '',
    insuranceEffectiveDate: null,
    insuranceExpirationDate: null,
    isNew: true,
    carrierStatusId: 'AVAILABLE',
    orgId
  };
};

export const sanitize = values => {
  const { id, rowVersion, orgId, leadTimeWindow, ...initialValues } = _pick(
    values,
    FIELDS
  );

  const leadTimeWindowMinutes = leadTimeWindow * MINUTES_IN_A_HOUR;

  if (id) {
    return {
      ...initialValues,
      leadTimeWindowMinutes,
      id,
      rowVersion
    };
  }
  return {
    ...initialValues,
    leadTimeWindowMinutes,
    orgId
  };
};

export default CarrierRelationship;
